import { Component, Injector, OnInit } from '@angular/core';
import { Color } from 'src/app/config/color';
import { CanvasLayoutDataService } from 'src/app/submodules/angular-common/canvas-layout-data.service';
import { FormSettings } from 'src/app/submodules/angular-ui-common/forms/form-settings';
import { FormComponent } from 'src/app/submodules/angular-ui-common/forms/form.component';
import { HomeFormService } from './home-form.service';

@Component({
  selector: 'app-home-form',
  templateUrl: './home-form.component.html',
  styleUrls: ['./home-form.component.scss'],
  providers:  [ HomeFormService ]
})
export class HomeFormComponent extends FormComponent {

  private _reloadedItem: any;

  constructor(protected _injector: Injector, 
              public canvasLayoutDataService: CanvasLayoutDataService) { 
    super(_injector);
  }

  async ngOnInit() {
    await super.init()
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        firstName: { required: true },
        lastName: { required: true },
        email: { required: true },
        mobileNumber: { required: true },
        privacy: { required: true/*, admittedValue:true */},
        gender: {
          selectableOptions: [
            { id: 'M', label: 'M' },
            { id: 'F', label: 'F' }
          ]
        }
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[]; }> {
    this._reloadedItem = {}

    return this._toForm(this._reloadedItem);
  }
  
  /** @override */
  protected async _submitHook() {
    const data = this._fromForm(this.currentValues);
    await this._injector.get(HomeFormService).sendUserData(data.firstName,data.lastName,data.email,data.mobileNumber);

  }

  private  _toForm = (dto: any): { [key: string]: number | string | boolean | (string | number)[] | File | File[] } => {
    let result: { [key: string]: number | string | boolean | (string | number)[] | File | File[] } = {}
    result.firstName = dto.firstName;
    result.gender = dto.gender;
    return result;
  }

  private _fromForm = (model: { [key: string]: number | string | boolean | (string | number)[] | File | File[] }): any => {
    console.log('_fromForm :>> ');

    return {
      firstName:  model.firstName as string,
      lastName: model.lastName as string,
      email: model.email as string,
      mobileNumber: model.mobileNumber as string
    }
  }


}

